import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Theme Tracker panel art: three theme rows, each a label pill, a track holding
 * overlapping member-ticker dots, and a percent badge. One green, one red, one
 * flat.
 */

type Row = {
  cy: number
  tone: string
  badge: string
  /** Centre x of each member dot; they overlap by design. */
  dots: number[]
}

const ROWS: Row[] = [
  {
    cy: 24,
    tone: 'var(--chart-candle-up)',
    badge: 'hsl(var(--positive) / 0.35)',
    dots: [55, 64, 73, 82, 91],
  },
  {
    cy: 52,
    tone: 'var(--chart-candle-down)',
    badge: 'hsl(var(--negative) / 0.35)',
    dots: [55, 64, 73, 82],
  },
  {
    cy: 80,
    tone: 'var(--muted-foreground)',
    badge: 'hsl(var(--muted-foreground) / 0.45)',
    dots: [55, 64, 73, 82],
  },
]

/** Dots fade from left to right so the leading member reads first. */
const DOT_ALPHA = [0.75, 0.6, 0.5, 0.4, 0.3]

export function ThemeTrackerArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {ROWS.map((row) => (
        <g key={row.cy}>
          <rect
            x={12}
            y={row.cy - 5}
            width={30}
            height={10}
            rx={3}
            fill="hsl(var(--foreground) / 0.25)"
          />
          <rect
            x={48}
            y={row.cy - 5}
            width={66}
            height={10}
            rx={4}
            fill="hsl(var(--foreground) / 0.1)"
          />
          {row.dots.map((cx, index) => (
            <circle
              key={cx}
              cx={cx}
              cy={row.cy}
              r={5}
              fill={`hsl(${row.tone} / ${DOT_ALPHA[index]})`}
              stroke="hsl(var(--card))"
              strokeWidth="1.5"
              vectorEffect="non-scaling-stroke"
            />
          ))}
          <rect x={120} y={row.cy - 5} width={28} height={10} rx={3} fill={row.badge} />
        </g>
      ))}
    </svg>
  )
}
